import styled from 'styled-components';

export const TrimaRankingMainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;
